<!--
 * @Description: 商品流通看板
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:55:16
 * @LastEditTime: 2020-12-22 15:35:07
-->
<template>
  <div class="board-goods-circulation">
    <transition name="el-fade-in">
      <p class="f11-toast" ref="f11Toast" v-if="showF11Toast">
        <i class="e6-icon-tips_line tips_line"></i>按 F11 可进入全屏
      </p>
    </transition>
    <div class="board-header">
      <div class="board-title"></div>
      <div class="board-time">{{ time }}</div>
    </div>
    <div class="board-main">
      <!-- 看板左边 -->
      <div class="board-left">
        <div
          class="board-left-top"
          v-loading="goodsTodaySummaryLoading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <!-- 国产商品 -->
          <div class="domestic-goods">
            <h3 class="domestic-goods__title">当日国产商品数据</h3>
            <div class="domestic-goods__inflow">
              <div class="domestic-goods__inflow--icon"></div>
              <div class="domestic-goods__inflow--content">
                <div class="domestic-goods__inflow--num">
                  {{ goodsTodaySummary.nationalIn }}
                </div>
                <div class="domestic-goods__inflow--title">
                  国产商品当天流入批次数
                </div>
              </div>
            </div>
            <div class="domestic-goods__outflow">
              <div class="domestic-goods__outflow--icon"></div>
              <div class="domestic-goods__outflow--content">
                <div class="domestic-goods__outflow--num">
                  {{ goodsTodaySummary.nationalOut }}
                </div>
                <div class="domestic-goods__outflow--title">
                  国产商品当天流出批次数
                </div>
              </div>
            </div>
          </div>
          <!-- 进口商品 -->
          <div class="import-goods">
            <h3 class="import-goods__title">当日进口商品数据</h3>
            <div class="import-goods__inflow">
              <div class="import-goods__inflow--icon"></div>
              <div class="import-goods__inflow--content">
                <div class="import-goods__inflow--num">
                  {{ goodsTodaySummary.foreignIn }}
                </div>
                <div class="import-goods__inflow--title">
                  进口商品当天流入批次数
                </div>
              </div>
            </div>
            <div class="import-goods__outflow">
              <div class="import-goods__outflow--icon"></div>
              <div class="import-goods__outflow--content">
                <div class="import-goods__outflow--num">
                  {{ goodsTodaySummary.foreignOut }}
                </div>
                <div class="import-goods__outflow--title">
                  进口商品当天流出批次数
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="board-left-bottom"
          v-loading="goodsTypeCirculationLoading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <div class="board-left-bottom--title">
            <h3 class="left-bottom-title">商品类型流通占比图</h3>
            <ul class="left-bottom-switch">
              <li
                :class="[
                  'left-bottom-switch--item',
                  goodsTypeCirculationAcitve === 0 ? 'active' : '',
                ]"
                @click="handleGoodsTypeCirculationClick(0)"
              >
                昨日
              </li>
              <li
                :class="[
                  'left-bottom-switch--item',
                  goodsTypeCirculationAcitve === 1 ? 'active' : '',
                ]"
                @click="handleGoodsTypeCirculationClick(1)"
              >
                近7日
              </li>
              <li
                :class="[
                  'left-bottom-switch--item',
                  goodsTypeCirculationAcitve === 2 ? 'active' : '',
                ]"
                @click="handleGoodsTypeCirculationClick(2)"
              >
                近1月
              </li>
            </ul>
          </div>
          <div class="board-left-bottom--content">
            <!-- 图例 -->
            <div class="left-bottom-legend">
              <div
                class="left-bottom-legend--item"
                v-for="(legend, index) in goodsTypeCirculation.legends"
                :key="`goodsTypeCirculation${index}`"
              >
                <div class="left-bottom-legend--icon"></div>
                <div class="left-bottom-legend--text">
                  {{ legend }}
                </div>
              </div>
            </div>
            <!-- 图表区域 -->
            <div class="left-bottom-chart">
              <div class="left-bottom-chart--item">
                <div
                  class="chart-item--content"
                  ref="homeInflowGoodsTypeChart"
                  v-show="nationalInRate.length !== 0"
                ></div>
                <div
                  class="chart-item--nodata"
                  v-show="nationalInRate.length === 0"
                >
                  <img
                    src="../../../assets/images/pg-nodata-dark.png"
                    alt="无数据"
                  />
                  <p>无数据</p>
                </div>
                <div class="chart-item--title">国内商品类型流入占比</div>
              </div>
              <div class="left-bottom-chart--item">
                <div
                  class="chart-item--content"
                  ref="abroadInflowGoodsTypeChart"
                  v-show="foreignInRate.length !== 0"
                ></div>
                <div
                  class="chart-item--nodata"
                  v-show="foreignInRate.length === 0"
                >
                  <img
                    src="../../../assets/images/pg-nodata-dark.png"
                    alt="无数据"
                  />
                  <p>无数据</p>
                </div>
                <div class="chart-item--title">国外商品类型流入占比</div>
              </div>
              <div class="left-bottom-chart--item">
                <div
                  class="chart-item--content"
                  ref="homeOutflowGoodsTypeChart"
                  v-show="nationalOutRate.length !== 0"
                ></div>
                <div
                  class="chart-item--nodata"
                  v-show="nationalOutRate.length === 0"
                >
                  <img
                    src="../../../assets/images/pg-nodata-dark.png"
                    alt="无数据"
                  />
                  <p>无数据</p>
                </div>
                <div class="chart-item--title">国内商品类型流出占比</div>
              </div>
              <div class="left-bottom-chart--item">
                <div
                  class="chart-item--content"
                  ref="abroadOutflowGoodsTypeChart"
                  v-show="foreignOutRate.length !== 0"
                ></div>
                <div
                  class="chart-item--nodata"
                  v-show="foreignOutRate.length === 0"
                >
                  <img
                    src="../../../assets/images/pg-nodata-dark.png"
                    alt="无数据"
                  />
                  <p>无数据</p>
                </div>
                <div class="chart-item--title">国外商品类型流出占比</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 看板右边 -->
      <div
        class="board-right"
        v-loading="goodsCirculationMapLoading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- 国内国外切换 -->
        <div class="board-right-top"></div>
        <div class="board-right-bottom" ref="goodsCirculationMap"></div>
        <div class="right-bottom-legend">
          <div class="right-bottom-legend--item">
            <div class="right-bottom-legend--icon"></div>
            <div class="right-bottom-legend--text">流入</div>
          </div>
          <div class="right-bottom-legend--item">
            <div class="right-bottom-legend--icon"></div>
            <div class="right-bottom-legend--text">流出</div>
          </div>
          <div class="right-bottom-legend--item">
            <div class="right-bottom-legend--icon"></div>
            <div class="right-bottom-legend--text">管辖仓库</div>
          </div>
          <div class="right-bottom-legend--item">
            <div class="right-bottom-legend--icon"></div>
            <div class="right-bottom-legend--text">城市</div>
          </div>
          <div class="right-bottom-legend--item">
            <div class="right-bottom-legend--icon"></div>
            <div class="right-bottom-legend--text">收货</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import echarts from "echarts";
import { cloneDeep } from "lodash";
import {
  fetchGoodsTodaySummary,
  fetchGoodsTypeCirculation,
  fetchcirculationData,
  fetchcirculationCity,
} from "@/api/board/goodsCirculation";
import china from "@/assets/geo/goodsCirculation/china.json";

export default {
  data() {
    return {
      showF11Toast: true, // 展示 f11 进入全屏 toast
      time: "", // 时间
      timer: null, // 时间定时器
      goodsTodaySummaryLoading: false, // 商品当日流通数据
      goodsTypeCirculationLoading: false, // 商品类型流通占比
      goodsCirculationMapLoading: false, // 商品流通看板地图 loading
      // 当日商品流通数据
      goodsTodaySummary: {
        foreignIn: 0,
        foreignOut: 0,
        nationalIn: 0,
        nationalOut: 0,
      },
      goodsTypeCirculation: {
        startTime: "", // 商品类型流通占比开始时间
        endTime: "", // 商品类型流通占比结束时间
        colorList: [
          "#3bafff",
          "#3feed4",
          "#f1bb4c",
          "#afa3f5",
          "#e98f6c",
          "#93c9ff",
        ], // 商品类型流通颜色列表
        legends: [],
      },
      goodsTypeCirculationAcitve: 0, // 商品类型流通 active
      goodsTypeCirculationTimer: null, // 商品类型流通定时器
      homeInflowGoodsTypeChart: null, // 国内商品类型流入占比
      abroadInflowGoodsTypeChart: null, // 国外商品类型流入占比
      homeOutflowGoodsTypeChart: null, // 国内商品类型流出占比
      abroadOutflowGoodsTypeChart: null, // 国外商品类型流出占比
      goodsCirculationMap: null, // 商品流通地图
      foreignInRate: [], // 国外商品类型流入
      foreignOutRate: [], // 国外商品类型流出
      nationalInRate: [], // 国内商品类型流入
      nationalOutRate: [], // 国内商品类型流出
    };
  },
  created() {
    this.getTime();
    this.queryGoodsTodaySummary();
    this.getGoodsTypeCirculation(1);
  },
  mounted() {
    this.queryGoodsTypeCirculation();
    this.queryGoodsCirculation();
    this.setGoodsTypeCirculationTimer();
    window.addEventListener("resize", this.setResize);
    this.handleShowF11Toast(); // 清除按 f11 进入全屏的 toast
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.goodsTypeCirculationTimer);
    this.goodsTypeCirculationTimer = null;
    window.removeEventListener("resize", this.setResize);
  },
  methods: {
    // 获取当日商品流通数据
    async queryGoodsTodaySummary() {
      try {
        this.goodsTodaySummaryLoading = true;
        let res = await fetchGoodsTodaySummary();
        if (res.code === 1 && res.result) {
          this.goodsTodaySummary.foreignIn = res.result.foreignIn;
          this.goodsTodaySummary.foreignOut = res.result.foreignOut;
          this.goodsTodaySummary.nationalIn = res.result.nationalIn;
          this.goodsTodaySummary.nationalOut = res.result.nationalOut;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.goodsTodaySummaryLoading = false;
      }
    },
    // 获取商品类型流通占比
    async queryGoodsTypeCirculation() {
      try {
        this.goodsTypeCirculationLoading = true;
        let startTime = this.goodsTypeCirculation.startTime;
        let endTime = this.goodsTypeCirculation.endTime;
        let res = await fetchGoodsTypeCirculation({
          startTime,
          endTime,
        });
        if (res.code === 1 && res.result) {
          this.getGoodsTypeCirculationChart(res.result);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.goodsTypeCirculationLoading = false;
      }
    },
    // 获取商品流通数据
    async queryGoodsCirculation() {
      try {
        this.goodsCirculationMapLoading = true;
        let lineData = [];
        let pointData = [];
        let promiseList = [fetchcirculationData(), fetchcirculationCity()];
        let [resData, resCity] = await Promise.all(promiseList);

        if (resData.code === 1 && Array.isArray(resData.result)) {
          lineData = cloneDeep(resData.result);
        }
        if (resCity.code === 1 && Array.isArray(resCity.result)) {
          pointData = cloneDeep(resCity.result);
        }
        this.getGoodsCirCulationMap(lineData, pointData);
      } catch (error) {
        console.log(error);
      } finally {
        this.goodsCirculationMapLoading = false;
      }
    },
    // 获取商品类型占比图表
    getGoodsTypeCirculationChart(data) {
      // 处理当前请求到的数据
      let foreignInRate = data.foreignInRate || [];
      let foreignOutRate = data.foreignOutRate || [];
      let nationalInRate = data.nationalInRate || [];
      let nationalOutRate = data.nationalOutRate || [];
      this.foreignInRate = foreignInRate; // 国外商品类型流入
      this.foreignOutRate = foreignOutRate; // 国外商品类型流出
      this.nationalInRate = nationalInRate; // 国内商品类型流入
      this.nationalOutRate = nationalOutRate; // 国内商品类型流出
      let foreignInData = [];
      let foreignOutData = [];
      let nationalInData = [];
      let nationalOutData = [];
      let category = []; // 类目

      foreignInRate.forEach((item) => {
        foreignInData.push({
          name: item.categoryName,
          value: item.rate * 100,
          num: item.goodsNum,
        });
        category.push(item.categoryName);
      });

      foreignOutRate.forEach((item) => {
        foreignOutData.push({
          name: item.categoryName,
          value: item.rate * 100,
          num: item.goodsNum,
        });
        category.push(item.categoryName);
      });

      nationalInRate.forEach((item) => {
        nationalInData.push({
          name: item.categoryName,
          value: item.rate * 100,
          num: item.goodsNum,
        });
        category.push(item.categoryName);
      });

      nationalOutRate.forEach((item) => {
        nationalOutData.push({
          name: item.categoryName,
          value: item.rate * 100,
          num: item.goodsNum,
        });
        category.push(item.categoryName);
      });

      this.goodsTypeCirculation.legends = Array.from(new Set(category));

      // 判断是否需要初始化
      if (!this.homeInflowGoodsTypeChart) {
        this.homeInflowGoodsTypeChart = echarts.init(
          this.$refs.homeInflowGoodsTypeChart
        );
      }
      if (!this.homeOutflowGoodsTypeChart) {
        this.homeOutflowGoodsTypeChart = echarts.init(
          this.$refs.homeOutflowGoodsTypeChart
        );
      }
      if (!this.abroadInflowGoodsTypeChart) {
        this.abroadInflowGoodsTypeChart = echarts.init(
          this.$refs.abroadInflowGoodsTypeChart
        );
      }
      if (!this.abroadOutflowGoodsTypeChart) {
        this.abroadOutflowGoodsTypeChart = echarts.init(
          this.$refs.abroadOutflowGoodsTypeChart
        );
      }

      let foreignInOption = this.getGoodsTypeCirculationChartOptions(
        foreignInData,
        "国外商品类型流入占比"
      );
      let foreignOutOption = this.getGoodsTypeCirculationChartOptions(
        foreignOutData,
        "国外商品类型流出占比"
      );
      let nationalInOption = this.getGoodsTypeCirculationChartOptions(
        nationalInData,
        "国内商品类型流入占比"
      );
      let nationalOutOption = this.getGoodsTypeCirculationChartOptions(
        nationalOutData,
        "国内商品类型流出占比"
      );

      this.$nextTick(() => {
        this.homeInflowGoodsTypeChart.resize();
        this.homeOutflowGoodsTypeChart.resize();
        this.abroadInflowGoodsTypeChart.resize();
        this.abroadOutflowGoodsTypeChart.resize();
      });

      this.homeInflowGoodsTypeChart.setOption(nationalInOption);
      this.homeOutflowGoodsTypeChart.setOption(nationalOutOption);
      this.abroadInflowGoodsTypeChart.setOption(foreignInOption);
      this.abroadOutflowGoodsTypeChart.setOption(foreignOutOption);
    },
    // 获取商品类型占比图表的配置
    getGoodsTypeCirculationChartOptions(data, title) {
      let colorList = this.goodsTypeCirculation.colorList;
      let option = {
        // title: {
        //   text: title,
        //   textStyle: {
        //     fontSize: 16,
        //     color: "#bad7ff"
        //   },
        //   textAlign: "center",
        //   bottom: "4%",
        //   left: "50%"
        // },
        label: {
          formatter: (params) => {
            let data = params.data;
            return `{title|${data.name}}\n{num|${data.num}}{rate|(${data.value}%)}`;
          },
          rich: {
            title: {
              fontSize: 12,
              height: 14,
              color: "rgba(255, 255, 255, 0.4)",
            },
            num: {
              color: "#ffffff",
              fontSize: 12,
            },
            rate: {
              color: "#afa3f5",
              fontSize: 12,
            },
          },
        },
        series: [
          // 主要展示层的
          {
            radius: ["22%", "60%"],
            center: ["50%", "50%"],
            type: "pie",
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex];
                },
              },
            },
            data: data,
          },
          // 边框的设置
          {
            radius: ["55%", "60%"],
            center: ["50%", "50%"],
            type: "pie",
            animation: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: data.length !== 0 ? [{ value: 1 }] : [],
          },
        ],
      };

      return option;
    },
    // 获取商品流通占比图表数据
    getGoodsTypeCirculation(type) {
      switch (type) {
        // 昨日
        case 1:
          this.goodsTypeCirculation.startTime = moment()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.goodsTypeCirculation.endTime = moment()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
        // 近7日
        case 2:
          this.goodsTypeCirculation.startTime = moment()
            .subtract(7, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.goodsTypeCirculation.endTime = moment()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
        // 近1月
        case 3:
          this.goodsTypeCirculation.startTime = moment()
            .subtract(30, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.goodsTypeCirculation.endTime = moment()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          break;

        default:
          this.goodsTypeCirculation.startTime = moment()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.goodsTypeCirculation.endTime = moment()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
      }
    },
    // 初始化地图
    getGoodsCirCulationMap(lineData, pointData) {
      if (!this.goodsCirculationMap) {
        // 创建 echarts 实例
        this.goodsCirculationMap = echarts.init(this.$refs.goodsCirculationMap);
        // 注册地图
        echarts.registerMap("china", china);
      }
      let scatterList = []; // 城市点
      let scatterGoodsList = []; // 商品点
      let effectScatterList = []; // 带涟漪的点
      let inFlowLineList = []; // 流入线
      let outFlowLineList = []; // 流出线
      let lineObj = {}; // 线对象

      pointData.forEach((point) => {
        // 城市
        if (point.type === 0) {
          scatterList.push({
            name: point.name,
            value: point.location,
          });
        }

        // 商品
        if (point.type === 2) {
          scatterGoodsList.push({
            name: point.name,
            value: point.location,
          });
        }

        // 管辖仓库
        if (point.type === 1) {
          effectScatterList.push({
            name: point.name,
            value: point.location,
          });
        }
        lineObj[point.name] = point.location;
      });

      let lineDataRandom = [];
      for (let i = 0; i < lineData.length; i++) {
        let n = this.getRandomNumber(lineDataRandom);
        lineDataRandom.push(n);
      }

      console.log(lineDataRandom);

      lineData.forEach((line, lineIndex) => {
        // 流入
        if (line.to.color === 1) {
          inFlowLineList.push({
            from: line.from,
            to: line.to.destination,
            code: line.to.code,
            goodsName: line.to.goodsName,
            coords: [lineObj[line.from], lineObj[line.to.destination]],
            value: line.to.goodsNum,
            lineStyle: {
              curveness: lineDataRandom[lineIndex],
            },
          });
        }
        // 流出
        if (line.to.color === 0) {
          outFlowLineList.push({
            from: line.from,
            to: line.to.destination,
            code: line.to.code,
            goodsName: line.to.goodsName,
            coords: [lineObj[line.from], lineObj[line.to.destination]],
            value: line.to.goodsNum,
            lineStyle: {
              curveness: lineDataRandom[lineIndex],
            },
          });
        }
      });

      let lineColor = ["#3bafff", "#f1bb4c"]; // 航线颜色 [流入, 流出]

      let option = {
        tooltip: {
          show: true,
        },
        legend: {
          show: true,
          top: 0,
        },
        geo: [
          // 省份地图
          {
            map: "china",
            boundingCoords: [
              [80.307454, 52.279724],
              [136.116047, 20.289304],
            ],
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#93c9ff",
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#93c9ff",
                },
              },
            },
            center: [103.21175, 35.2845],
            zoom: 1,
            itemStyle: {
              normal: {
                areaColor: "rgba(64, 80, 245, 0.1)",
                borderColor: "rgba(64, 80, 245, 0.3)",
                borderWidth: 1,
              },
              emphasis: {
                areaColor: "rgba(64, 80, 245, 0.1)",
                borderColor: "rgba(64, 80, 245, 0.3)",
                borderWidth: 1,
              },
            },
            regions: [
              {
                name: "china_board",
                label: {
                  normal: {
                    show: false,
                  },
                  emphasis: {
                    show: false,
                  },
                },
                itemStyle: {
                  normal: {
                    borderWidth: 2, //设置外层边框
                    borderColor: "#4a75ff",
                    shadowBlur: 10,
                    shadowColor: "#4a75ff",
                  },
                  emphasis: {
                    borderWidth: 2, //设置外层边框
                    borderColor: "#4a75ff",
                    shadowBlur: 10,
                    shadowColor: "#4a75ff",
                  },
                },
              },
              {
                name: "南海诸岛",
                itemStyle: {
                  normal: {
                    borderWidth: 2, //设置外层边框
                    borderColor: "#4a75ff",
                    shadowBlur: 10,
                    shadowColor: "#4a75ff",
                  },
                  emphasis: {
                    borderWidth: 2, //设置外层边框
                    borderColor: "#4a75ff",
                    shadowBlur: 10,
                    shadowColor: "#4a75ff",
                  },
                },
              },
            ],
          },
        ],
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo",
            tooltip: {
              formatter: (params) => {
                return params.data.name;
              },
            },
            zlevel: 2,
            itemStyle: {
              color: "#93c9ff",
            },
            data: scatterList,
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            tooltip: {
              formatter: (params) => {
                return params.data.name;
              },
            },
            zlevel: 2,
            itemStyle: {
              color: "#afa3f5",
            },
            data: scatterGoodsList,
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            tooltip: {
              formatter: (params) => {
                return params.data.name;
              },
            },
            itemStyle: {
              color: "#93c9ff",
            },
            zlevel: 2,
            rippleEffect: {
              brushType: "stroke",
              scale: 1.7,
            },
            symbolSize: 25,
            data: effectScatterList,
          },
          {
            type: "lines",
            lineStyle: {
              color: lineColor[0],
              width: 3, // 线条宽度
              // curveness: 0.3 // 尾迹线条曲直度
            },
            effect: {
              show: true,
              period: 3, //箭头指向速度，值越小速度越快
              trailLength: 0, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "triangle", //箭头图标
              symbolSize: 16, //图标大小
            },
            tooltip: {
              show: true,
              formatter: (params) => {
                console.log(params);
                let data = params.data;
                return `批次编码: ${data.code}<br />${data.from}→${data.to}<br />${data.goodsName}(${data.value}件)`;
              },
            },
            data: inFlowLineList,
          },
          {
            type: "lines",
            lineStyle: {
              color: lineColor[1],
              width: 3, // 线条宽度
              // curveness: 0.3 // 尾迹线条曲直度
            },
            effect: {
              show: true,
              period: 3, //箭头指向速度，值越小速度越快
              trailLength: 0, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "triangle", //箭头图标
              symbolSize: 16, //图标大小
            },
            tooltip: {
              show: true,
              formatter: (params) => {
                console.log(params);
                let data = params.data;
                return `批次编码: ${data.code}<br />${data.from}→${data.to}<br />${data.goodsName}(${data.value}件)`;
              },
            },
            data: outFlowLineList,
          },
        ],
      };

      this.goodsCirculationMap.setOption(option);
    },
    // 获取不重复的 0-1 之间的随机数
    getRandomNumber(arr) {
      let result = 0;
      let num = Math.random(); // 生城 0-1之间的随机数
      if (arr.includes(num)) {
        result = this.getRandomNumber(arr);
      } else {
        result = num;
      }
      return result;
    },
    // 处理商品类型流通占比图点击 switch
    handleGoodsTypeCirculationClick(index) {
      this.goodsTypeCirculationAcitve = index;
      this.setGoodsTypeCirculationTimer();
      // 昨日
      if (index === 0) {
        this.getGoodsTypeCirculation(1);
      }
      // 近7日
      if (index === 1) {
        this.getGoodsTypeCirculation(2);
      }
      // 近1月
      if (index === 2) {
        this.getGoodsTypeCirculation(3);
      }
      this.queryGoodsTypeCirculation();
    },
    // 设置商品类型定时器
    setGoodsTypeCirculationTimer() {
      const TIME_INTERVAL = 30 * 1000; // 30s
      if (this.goodsTypeCirculationTimer) {
        clearInterval(this.goodsTypeCirculationTimer);
        this.goodsTypeCirculationTimer = null;
      }
      this.goodsTypeCirculationTimer = setInterval(() => {
        if (this.goodsTypeCirculationAcitve < 2) {
          this.handleGoodsTypeCirculationClick(
            this.goodsTypeCirculationAcitve + 1
          );
        } else {
          this.handleGoodsTypeCirculationClick(0);
        }
      }, TIME_INTERVAL);
    },
    setResize() {
      if (this.homeInflowGoodsTypeChart) {
        this.homeInflowGoodsTypeChart.resize();
      }
      if (this.homeOutflowGoodsTypeChart) {
        this.homeOutflowGoodsTypeChart.resize();
      }
      if (this.abroadInflowGoodsTypeChart) {
        this.abroadInflowGoodsTypeChart.resize();
      }
      if (this.abroadOutflowGoodsTypeChart) {
        this.abroadOutflowGoodsTypeChart.resize();
      }
      if (this.goodsCirculationMap) {
        this.goodsCirculationMap.resize();
      }
    },
    getTime() {
      const TIME_INTERVAL = 1000; // 1s
      this.timer = setInterval(() => {
        this.time = moment().format("YYYY-MM-DD HH:mm:ss");
      }, TIME_INTERVAL);
    },
    // 隐藏按 f11 进入全屏
    handleShowF11Toast() {
      let timer = setTimeout(() => {
        this.showF11Toast = false;
        clearTimeout(timer);
        timer = null;
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "LEDNumber";
  src: url(../../../assets/ledFont/LEDNum.eot); /***兼容ie9***/
  src: url(../../../assets/ledFont/LEDNum.eot?#iefix)
      format("embedded-opentype"),
    /***兼容ie6-ie8***/ url("../../../assets/ledFont/LEDNum.woff")
      format("woff"),
    local("LEDNum"), url("../../../assets/ledFont/LEDNum.woff"); /***默认使用本地的***/
}
.board-goods-circulation {
  width: 100%;
  height: 100%;
  background-color: #09121b;
  background-image: url("../../../assets/images/goodsCirculationBoard/bg.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;
  .f11-toast {
    position: absolute;
    left: 50%;
    top: 0.8rem;
    width: 2rem;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.3);
    height: 0.5rem;
    line-height: 0.5rem;
    margin-left: -1rem;
    z-index: 10;
    text-align: center;
    border-radius: 4px;
    font-size: 0.14rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    .tips_line {
      font-size: 0.2rem;
      margin-right: 0.1rem;
    }
  }
  .board-header {
    width: 100%;
    height: 0.89rem;
    padding-top: 0.15rem;
    box-sizing: border-box;
    position: relative;
    background-image: url("../../../assets/images/goodsCirculationBoard/title-bg.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    .board-title {
      width: 1.94rem;
      height: 0.3rem;
      margin: 0 auto;
      background-image: url("../../../assets/images/goodsCirculationBoard/title.png");
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
    }
    .board-time {
      font-family: "LEDNumber";
      position: absolute;
      left: 0.27rem;
      top: 0.15rem;
      font-size: 0.22rem;
      color: #3f83ff;
      word-spacing: 0.28rem;
    }
  }

  .board-main {
    width: 100%;
    height: calc(100% - 0.89rem);
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 0.1rem 0.1rem 0.1rem;
  }

  .board-left {
    width: 6.22rem;
    height: 100%;
    .board-left-top {
      width: 100%;
      height: 2.82rem;
      display: flex;
      background-image: url("../../../assets/images/goodsCirculationBoard/left-top-bg.png");
      background-size: 100% 100%;
      background-position: center center;
      background-repeat: no-repeat;
      .domestic-goods,
      .import-goods {
        width: 50%;
        height: 100%;
        color: #bad7ff;
        font-size: 0.16rem;
        &__title {
          text-align: center;
          margin: 0;
          line-height: 0.65rem;
          font-weight: normal;
        }
        &__inflow,
        &__outflow {
          display: flex;
          padding-left: 0.34rem;
          &--icon {
            width: 0.8rem;
            height: 0.8rem;
            background-size: 100% 100%;
            background-position: center center;
            background-repeat: no-repeat;
          }
          &--content {
            margin-left: 0.22rem;
          }
          &--title {
            font-size: 0.14rem;
            color: rgba(255, 255, 255, 0.7);
          }
          &--num {
            font-family: "Impact", Arial, Helvetica, sans-serif;
            font-size: 0.36rem;
            line-height: 0.36rem;
            margin: 0.08rem 0 0.12rem 0;
          }
        }
        &__inflow {
          &--icon {
            background-image: url("../../../assets/images/goodsCirculationBoard/inflow.png");
          }
          &--num {
            color: #3bafff;
          }
        }
        &__outflow {
          margin-top: 0.3rem;
          &--icon {
            background-image: url("../../../assets/images/goodsCirculationBoard/outflow.png");
          }
          &--num {
            color: #f1bb4c;
          }
        }
      }
    }
    .board-left-bottom {
      width: 100%;
      height: calc(100% - 2.82rem - 0.3rem);
      margin-top: 0.3rem;
      &--title {
        box-sizing: border-box;
        width: 100%;
        height: 0.3rem;
        padding-left: 0.1rem;
        font-size: 0.16rem;
        color: #bad7ff;
        line-height: 0.3rem;
        background-image: url("../../../assets/images/goodsCirculationBoard/left-bottom-title.png");
        background-size: 100% 100%;
        background-position: center center;
        background-repeat: no-repeat;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left-bottom-title {
          font-weight: normal;
          margin: 0;
          font-size: 0.16rem;
        }
        .left-bottom-switch {
          display: flex;
          height: 0.2rem;
          padding-right: 0.32rem;
          &--item {
            font-size: 0.12rem;
            color: #7b89dc;
            cursor: pointer;
            height: 0.2rem;
            line-height: 0.2rem;
            padding: 0 0.06rem;
            border-radius: 0.03rem;
            & + .left-bottom-switch--item {
              margin-left: 0.06rem;
            }
            &:hover {
              color: #ffffff;
              background-color: #7b89dc;
            }
          }
          .active {
            color: #ffffff;
            background-color: #7b89dc;
          }
        }
      }
      &--content {
        width: 100%;
        height: calc(100% - 0.3rem);
        background-image: url("../../../assets/images/goodsCirculationBoard/left-bottom-bg2.png");
        background-size: 100% 100%;
        background-position: center center;
        background-repeat: no-repeat;
        .left-bottom-legend {
          width: 100%;
          height: 0.3rem;
          line-height: 0.3rem;
          color: #7b89dc;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          &--item {
            font-size: 0.12rem;
            line-height: 0.12rem;
            display: flex;
            align-items: center;
            & + .left-bottom-legend--item {
              margin-left: 0.1rem;
            }
          }
          &--icon {
            width: 0.15rem;
            height: 0.08rem;
            margin-right: 0.05rem;
            border-radius: 0.02rem;
          }
          &--item:nth-child(1) {
            .left-bottom-legend--icon {
              background-color: #3bafff;
            }
          }
          &--item:nth-child(2) {
            .left-bottom-legend--icon {
              background-color: #3feed4;
            }
          }
          &--item:nth-child(3) {
            .left-bottom-legend--icon {
              background-color: #f1bb4c;
            }
          }
          &--item:nth-child(4) {
            .left-bottom-legend--icon {
              background-color: #afa3f5;
            }
          }
          &--item:nth-child(5) {
            .left-bottom-legend--icon {
              background-color: #e98f6c;
            }
          }
          &--item:nth-child(6) {
            .left-bottom-legend--icon {
              background-color: #93c9ff;
            }
          }
        }
        .left-bottom-chart {
          height: calc(100% - 0.3rem);
          display: flex;
          flex-wrap: wrap;
          &--item {
            width: 50%;
            height: 50%;
          }
          .chart-item--content {
            width: 100%;
            height: calc(100% - 0.26rem);
          }
          .chart-item--nodata {
            width: 100%;
            height: calc(100% - 0.26rem);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            & > img {
              display: block;
              height: calc(70% - 0.3rem - 0.14rem);
              margin: 0 auto;
            }
            & > p {
              font-size: 0.14rem;
              line-height: 0.14rem;
              color: #666666;
              text-align: center;
              margin: 0.15rem 0;
            }
          }
          .chart-item--title {
            font-size: 0.16rem;
            padding-bottom: 0.1rem;
            line-height: 0.16rem;
            color: #bad7ff;
            text-align: center;
          }
        }
      }
    }
  }

  .board-right {
    width: calc(100% - 6.5rem);
    height: 100%;
    background-image: url("../../../assets/images/goodsCirculationBoard/right-bg.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
    .board-right-top {
      width: 100%;
      height: 0.53rem;
    }
    .board-right-bottom {
      width: 100%;
      height: calc(100% - 0.53rem);
    }
    .right-bottom-legend {
      position: absolute;
      left: 0.38rem;
      bottom: 0.3rem;
      display: flex;
      &--item {
        color: #7b89dc;
        display: flex;
        align-items: center;
        & + .right-bottom-legend--item {
          margin-left: 0.26rem;
        }
        &:nth-child(1) {
          .right-bottom-legend--icon {
            width: 0.29rem;
            height: 0.13rem;
            margin-right: 0.1rem;
            background-image: url("../../../assets/images/goodsCirculationBoard/inflow-legend.png");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
        &:nth-child(2) {
          .right-bottom-legend--icon {
            width: 0.29rem;
            height: 0.13rem;
            margin-right: 0.1rem;
            background-image: url("../../../assets/images/goodsCirculationBoard/outflow-legend.png");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
        &:nth-child(3) {
          .right-bottom-legend--icon {
            width: 0.45rem;
            height: 0.45rem;
            background-image: url("../../../assets/images/goodsCirculationBoard/effectScatter.png");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
        &:nth-child(4) {
          .right-bottom-legend--icon {
            width: 0.1rem;
            height: 0.1rem;
            margin-right: 0.1rem;
            background-image: url("../../../assets/images/goodsCirculationBoard/scatter.png");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
        &:nth-child(5) {
          .right-bottom-legend--icon {
            width: 0.1rem;
            height: 0.1rem;
            margin-right: 0.1rem;
            background-color: #afa3f5;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>

<style>
.app-wrapper .e6-header-section {
  display: none;
}
.app-wrapper .e6-container-section {
  height: 100vh !important;
}
</style>
